<template>
<div class="env-container">
	<div v-if="isShowDdEnv" class="dd-env">
        <div class="env-container">
            <div class="">
                环境：<input type="text" placeholder="" v-model="envData" name="" value="">
            </div>
            <div class="env-btn">
                <button @click="isShowDdEnv=false">取消</button>
                <button @click="submit">确定</button>
            </div>
        </div>
    </div>
    <div @click="envBallHandle" class="env-ball">env</div>
</div>
</template>

<script>
import storage from '../../utils/storage'
export default {
	name: 'TestEnv',
	data() {
		return {
            isShowDdEnv:false,
			envData: '',
			dialogVisible: false
		}
	},
	mounted() {

	},
	methods: {
        envBallHandle(){
            this.isShowDdEnv=true
        },
		submit() {
            console.log(this.envData,'this.envData');
            storage.set({'ENV_API':this.envData})
			this.isShowDdEnv=false
            setTimeout(()=>{
                window.location.reload()
            },300)
		}
	}
}
</script>



// WEBPACK FOOTER //
// index.vue?78b7a879